import React, { useEffect, useRef, useState } from "react";
import { func, object, string } from "prop-types";
import DatePicker from "react-datepicker";

import "./datePicker.m.css";

const ReactDatePicker = ({ onDateSelect, src, fromDate, toDate, startPlaceholder, endPlaceholder }) => {
  const [startDate, setStartDate] = useState(fromDate);
  const [endDate, setEndDate] = useState(toDate);
  const datePickerRef = useRef(null);
  const containerStyle = `${src ? `${src}-date-picker` : "date-picker"}`;

  const fromDateSelect = (date, fromTo) => {
    setStartDate(date);
    onDateSelect(date, fromTo);
  };

  const toDateSelect = (date, fromTo) => {
    setEndDate(date);
    onDateSelect(date, fromTo);
  };

  useEffect(() => {
    const inputElements = datePickerRef.current.getElementsByTagName("input");
    Array.from(inputElements).forEach((item) => (item.readOnly = true));
  }, []);

  return (
    <div styleName={containerStyle} ref={datePickerRef}>
      <DatePicker
        selected={startDate}
        onChange={(date) => fromDateSelect(date, "from")}
        startDate={startDate}
        endDate={endDate}
        placeholderText={startPlaceholder}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
      {src !== "edit-profile" && (
        <>
          <span styleName="date-to">To</span>
          <DatePicker
            selected={endDate}
            onChange={(date) => toDateSelect(date, "to")}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText={endPlaceholder}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />
        </>
      )}
    </div>
  );
};

ReactDatePicker.propTypes = {
  onDateSelect: func,
  src: string,
  startPlaceholder: string,
  endPlaceholder: string,
  toDate: object,
  fromDate: object,
};

export default ReactDatePicker;
